import axios from 'axios'
import { MyIDUser } from '@genome-web-forms/common/auth'
import { authCWR } from './auth'
import config from 'shared/config'

export interface AiChatRequest {
    message: string
}

export interface AiChatResponse {
    response: string
}

export async function sendAiChatMessage(user: MyIDUser, message: string): Promise<AiChatResponse> {
    const response = await axios.request<AiChatResponse>(
        authCWR(user, {
            method: 'POST',
            url: `${config.urlGWFOntology}/ai/chat`,
            data: { message } as AiChatRequest,
        }),
    )
    return response.data
}
